import { AxiosResponse } from "axios";
import { toast } from "sonner";

export default function useHandleDownloadDocument() {
    const handleDownloadDocument = async (service: any, documentId: string, documentName: string, mimeType: string = 'application/octet-stream') => {
        try {
            const response = await service(documentId);

            if (response && response.getResponseData()) {
                const fileData = response.getResponseData();

                // Verificar que los datos no estén vacíos
                if (fileData) {
                    // Crear un blob con el tipo MIME proporcionado
                    const blob = new Blob([fileData], { type: mimeType });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', documentName);

                    // Descargar el archivo
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    toast.success('Documento descargado con éxito');
                } else {
                    toast.error('El documento está vacío o no se pudo obtener el archivo');
                }
            } else {
                toast.error('Error al descargar el documento');
            }
        } catch (error: any) {
            toast.error(`Error al descargar el documento: ${error.message}`);
        }
    };

    const handleDownloadDocumentNewTab = async (service: any, documentId: string, documentName: string, extension: string = 'pdf') => {
        try {
            const response = (await service(documentId)).getResponse() as AxiosResponse;

            if (response.status === 200) {
                let mimeType = 'application/pdf'; // Por defecto, PDF

                if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
                    mimeType = `image/${extension}`;
                } else if (extension === 'txt') {
                    mimeType = 'text/plain';
                } else if (extension === 'doc' || extension === 'docx') {
                    mimeType = 'application/msword';
                }

                const blob = new Blob([response.data], { type: mimeType });
                const url = window.URL.createObjectURL(blob);

                if (extension === 'pdf') {
                    window.open(url, '_blank');
                }

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', documentName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                toast.error('Error al descargar el documento');
            }
        } catch (error: any) {
            console.error(error);
            toast.error(error.message || 'Error al descargar el documento');
        }
    };

    return { handleDownloadDocument, handleDownloadDocumentNewTab };
}
